import Vue from 'vue';
import button from '~lib/src/components/button.vue';
import input from '~lib/src/components/input.vue';
import form from '~lib/src/components/form.vue';
import select from '~lib/src/components/select.vue';
import checkbox from '~lib/src/components/checkbox.vue';
import mouseDistanceTracker from '~lib/src/components/mouse-distance-tracker.vue';
import mouseTimeTracker from '~lib/src/components/mouse-time-tracker.vue';
import arithmeticTracker from '~lib/src/components/arithmetic-tracker.vue';
import contactLink from '~lib/src/components/contact-link.vue';
import header from '~lib/src/components/header.vue';
import langSwitch from '~lib/src/components/lang-switch.vue';
import drawer from '~lib/src/components/drawer.vue';
import textTemplate from '~lib/src/components/text-template.vue';
import collapse from '~lib/src/components/collapse.vue';
import collapseItem from '~lib/src/components/collapse-item.vue';
import slideToggle from '~lib/src/components/slide-toggle.vue';
import tabs from '~lib/src/components/tabs.vue';
import progress from '~lib/src/components/progress.vue';
import loading from '~lib/src/components/alpha/loading.vue';

Vue.component('sf-button', button);
Vue.component('sf-input', input);
Vue.component('sf-form', form);
Vue.component('sf-select', select);
Vue.component('sf-checkbox', checkbox);
Vue.component('sf-mouse-distance-tracker', mouseDistanceTracker);
Vue.component('sf-mouse-time-tracker', mouseTimeTracker);
Vue.component('sf-arithmetic-tracker', arithmeticTracker);
Vue.component('sf-contact-link', contactLink);
Vue.component('sf-header', header);
Vue.component('sf-lang-switch', langSwitch);
Vue.component('sf-drawer', drawer);
Vue.component('sf-text-template', textTemplate);
Vue.component('sf-collapse', collapse);
Vue.component('sf-collapse-item', collapseItem);
Vue.component('sf-slide-toggle', slideToggle);
Vue.component('sf-tabs', tabs);
Vue.component('sf-progress', progress);
Vue.component('sf-loading', loading);
